export function createEventEmitter() {
  const listeners = new Map();
  const hasAnyListeners = () => {
    for (const set of listeners.values()) {
      if (set.size > 0) {
        return true;
      }
    }
    return false;
  };
  const count = channel => {
    var _listeners$get$size, _listeners$get;
    return (_listeners$get$size = (_listeners$get = listeners.get(channel)) === null || _listeners$get === void 0 ? void 0 : _listeners$get.size) !== null && _listeners$get$size !== void 0 ? _listeners$get$size : 0;
  };
  const unsubscribe = (channel, callback) => {
    var _listeners$get2;
    (_listeners$get2 = listeners.get(channel)) === null || _listeners$get2 === void 0 || _listeners$get2.delete(callback);
    const remaining = count(channel);
    if (remaining === 0) {
      listeners.delete(channel);
    }
    return remaining;
  };
  const emit = (channel, event) => {
    const callbacks = listeners.get(channel);
    if (!callbacks || count(channel) === 0) {
      return;
    }
    for (const callback of callbacks) {
      callback(event, () => unsubscribe(channel, callback));
    }
  };
  const subscribe = (channel, callback) => {
    if (!listeners.has(channel)) {
      listeners.set(channel, new Set());
    }
    listeners.get(channel).add(callback);
    return () => unsubscribe(channel, callback);
  };
  return {
    hasAnyListeners,
    count,
    emit,
    subscribe
  };
}